export function roleIdToRoleName(id: number) {
  let roleName = "";
  if (id === 1) {
    roleName = "HDB Master Administrator";
  } else if (id === 2) {
    roleName = "TC Administrator";
  } else if (id === 3) {
    roleName = "TC Operator";
  } else if (id === 4) {
    roleName = "Other Agency Administrator";
  } else if (id === 5) {
    roleName = "Other Agency Operator";
  } else if (id === 6) {
    roleName = "Other Agency User";
  } else if (id === 7) {
    roleName = "SLS Suppliers";
  } else if (id === 8) {
    roleName = "HDB View";
  } else if (id === 9) {
    roleName = "SLP Operator";
  }

  return roleName;
}
